<template>
  <div>
    <modal
      name="payment-modal"
      :resizable="true"
      :height="'auto'"
      :width="'100%'"
      :scrollable="true"
    >
    <!-- Nagłówek -->
    <div class="modal-header">
      <div class="header-content">
        <h4 v-if="payment && payment.contractor && payment.contractor.label" class="modal-title">
          {{ payment.contractor.label }}
        </h4>
        <h4 v-else class="modal-title text-muted">
          Ładowanie...
        </h4>
        <span class="payment-badge" :class="payment.type === 'Nalezności' ? 'badge-success' : 'badge-danger'">
          {{ payment.type || 'Nalezności' }}
        </span>
      </div>
      <button class="btn-close" @click="$emit('closeModal')" aria-label="Zamknij">
        <span aria-hidden="true">×</span>
      </button>
    </div>

    <!-- Ciało modalu -->
    <div class="modal-body" v-if="payment && payment.contractor">
      
      <!-- Karta kontrahenta -->
      <div class="contractor-card">
        <div class="section-header">
          <h5 class="section-title">Kontrahent</h5>
          <div v-if="payment.lastEmailSent" class="email-sent-badge">
            <span class="badge-icon">✉️</span>
            <div class="badge-content">
              <span class="badge-label">Ostatnie przypomnienie</span>
              <span class="badge-value">{{ formatDate(payment.lastEmailSent) }}</span>
            </div>
          </div>
        </div>
        <div class="contractor-grid">
          <div class="contractor-item">
            <span class="item-icon">🏢</span>
            <div class="item-content">
              <span class="item-label">Nazwa firmy</span>
              <span class="item-value">{{ payment.contractor.label }}</span>
            </div>
          </div>
          
          <div class="contractor-item">
            <span class="item-icon">📍</span>
            <div class="item-content">
              <span class="item-label">Adres</span>
              <span class="item-value">{{ payment.contractor.address }}</span>
            </div>
          </div>
          
          <div class="contractor-item">
            <span class="item-icon">📞</span>
            <div class="item-content">
              <span class="item-label">Telefon</span>
              <a class="item-value item-link" :href="`tel:${payment.contractor.phoneNumber}`">
                {{ payment.contractor.phoneNumber }}
              </a>
            </div>
          </div>
          
          <div class="contractor-item">
            <span class="item-icon">✉️</span>
            <div class="item-content">
              <span class="item-label">Email</span>
              <a class="item-value item-link" :href="`mailto:${payment.contractor.email}`">
                {{ payment.contractor.email }}
              </a>
            </div>
          </div>
          
          <div class="contractor-item">
            <span class="item-icon">🔢</span>
            <div class="item-content">
              <span class="item-label">NIP</span>
              <span class="item-value">{{ payment.contractor.nip }}</span>
            </div>
          </div>
          
          <div class="contractor-item">
            <span class="item-icon">👤</span>
            <div class="item-content">
              <span class="item-label">Osoba kontaktowa</span>
              <span class="item-value">{{ payment.contractor.contactPerson }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Formularz płatności -->
      <div class="payment-form">
        <h5 class="section-title">Szczegóły płatności</h5>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Numer faktury</label>
            <input
              v-model="payment.invoiceNumber"
              type="text"
              class="form-control"
              placeholder="Numer faktury"
            />
          </div>
          
          <div class="form-group">
            <label class="form-label">Data płatności</label>
            <input
              v-model="payment.date"
              type="date"
              class="form-control"
              placeholder="Data płatności"
            />
          </div>
          
          <div class="form-group">
            <label class="form-label">Kwota (PLN)</label>
            <input
              v-model="payment.price"
              type="text"
              class="form-control"
              placeholder="0.00"
            />
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Uwagi</label>
          <vue-editor
            class="editor-container"
            v-model="payment.notice"
          ></vue-editor>
        </div>
      </div>
    </div>

    <!-- Stopka z akcjami -->
    <div class="modal-footer">
      <div class="footer-actions footer-left">
        <button
          class="btn btn-outline-danger btn-sm"
          @click="deletepayment(payment)"
        >
          🗑️ Usuń płatność
        </button>
      </div>
      
      <div class="footer-actions footer-right">
        <div class="footer-type-selector">
          <label class="footer-label">Typ płatności</label>
          <v-select
            v-model="payment.type"
            :options="['Nalezności', 'Koszty']"
            placeholder="Wybierz typ"
            :searchable="false"
            :clearable="false"
            class="type-select"
            append-to-body
            :calculate-position="withPopper"
          >
          </v-select>
        </div>
        <button
          class="btn btn-secondary"
          @click="$emit('closeModal')"
        >
          ← Anuluj
        </button>
        <button
          id="sendEmailButton"
          class="btn btn-warning"
          @click="send(payment)"
        >
          ✉️ Wyślij przypomnienie
        </button>
        <button
          id="endPaymentButton"
          class="btn btn-success"
          @click="endPayment(payment)"
        >
          ✓ Dodaj płatność
        </button>
        <button
          id="editPaymentButton"
          class="btn btn-info"
          @click="updatePayment(payment)"
        >
          ✎ Zapisz zmiany
        </button>
      </div>
    </div>
  </modal>

  <!-- Toast Notification (poza modalem) -->
  <transition name="toast">
    <div v-if="toast.visible" class="toast-notification" :class="`toast-${toast.type}`">
      <span class="toast-icon">{{ toast.type === 'success' ? '✓' : toast.type === 'error' ? '✕' : 'ℹ' }}</span>
      <span class="toast-message">{{ toast.message }}</span>
    </div>
  </transition>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { VueEditor } from "vue2-editor";
import { createPopper } from "@popperjs/core";

export default {
  props: ["payment"],
  label: "",

  data() {
    return {
      imageUrl: "",
      consolelog: "test",
      toast: {
        visible: false,
        message: '',
        type: 'success' // success, error, info
      }
    };
  },
  components: {
    VueEditor,
  },
  computed: {
    ...mapState(["userProfile", "paymentUpdated"]),
  },

  methods: {
    showToast(message, type = 'success') {
      this.toast.message = message;
      this.toast.type = type;
      this.toast.visible = true;
      
      setTimeout(() => {
        this.toast.visible = false;
      }, 4000);
    },

    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width;
      
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: "top",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1],
            },
          },
          {
            name: "toggleClass",
            enabled: true,
            phase: "write",
            fn({ state }) {
              component.$el.classList.toggle(
                "drop-up",
                state.placement === "top"
              );
            },
          },
        ],
      });

      return () => popper.destroy();
    },

    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
      const now = new Date();
      const diffMs = now - date;
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMs / 3600000);
      const diffDays = Math.floor(diffMs / 86400000);
      
      if (diffMins < 1) return 'Przed chwilą';
      if (diffMins < 60) return `${diffMins} min temu`;
      if (diffHours < 24) return `${diffHours}h temu`;
      if (diffDays < 7) return `${diffDays} dni temu`;
      
      return date.toLocaleDateString('pl-PL', { 
        day: '2-digit', 
        month: '2-digit', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    async send(payment) {
      if (!payment.contractor || !payment.contractor.email) {
        this.showToast('Brak adresu email kontrahenta', 'error');
        return;
      }

      try {
        console.log('Wysyłanie emaila do:', payment.contractor.email);
        
        const response = await fetch('https://klim-bud.pl/wp-json/klimbud/v1/send-payment-reminder', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: payment.contractor.email,
            invoiceNumber: payment.invoiceNumber,
            price: payment.price,
            date: payment.date,
            contractorName: payment.contractor.label
          })
        });
        
        console.log('Response status:', response.status);
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error('Response error:', errorText);
          throw new Error(`Błąd serwera (${response.status}): ${errorText}`);
        }
        
        const data = await response.json();
        console.log('Response data:', data);
        
        if (data.success) {
          // Zapisz informację o wysłaniu emaila w Firestore
          await this.$store.dispatch('recordEmailSent', {
            id: payment.id,
            email: payment.contractor.email
          });
          
          this.showToast(`Email wysłany pomyślnie do ${payment.contractor.email}`, 'success');
        } else {
          throw new Error(data.error || data.message || 'Błąd wysyłania maila');
        }
      } catch (error) {
        console.error('Błąd wysyłania emaila:', error);
        this.showToast(`Nie udało się wysłać emaila: ${error.message}`, 'error');
      }
    },

    updatePayment(payment) {
      // console.log(payment.id);
      this.$store
        .dispatch("updatePayment", {
          id: payment.id,
          notice: payment.notice,
          price: payment.price,
          date: payment.date,
          type: payment.type,
        })
        .then(() => {
          if (this.paymentUpdated) {
            let button = document.getElementById("editPaymentButton");
            button.style.backgroundColor = "#409855";
            button.style.color = "#17801b";
            button.innerText = "Płatność została edytowana";
          }
          setTimeout(() => {
            let button = document.getElementById("editPaymentButton");
            button.style.backgroundColor = "#409855";
            button.style.color = "";
            button.innerText = "Płatność została edytowana";
            this.carUpdated = null;
          }, 200);
          setTimeout(() => {
            this.$emit("closeModal");
          }, 2000);
        });
    },

    endPayment(payment) {
      this.$store
        .dispatch("endPayment", {
          id: payment.id,
          status: "end",
        })
        .then(() => {
          if (this.paymentUpdated) {
            let button = document.getElementById("endPaymentButton");
            button.style.backgroundColor = "#409855";
            button.style.color = "#17801b";
            button.innerText = "Płatność została dodana";
          }
          setTimeout(() => {
            let button = document.getElementById("endPaymentButton");
            button.style.backgroundColor = "#409855";
            button.style.color = "";
            button.innerText = "Płatność została dodana";
            this.carUpdated = null;
          }, 200);
          setTimeout(() => {
            this.$emit("closeModal");
          }, 3000);
        });
    },

    deletepayment(payment) {
      if (confirm("Czy jesteś pewien ze chcesz usunąć płatność?")) {
        this.$store.dispatch("deletepayment", {
          id: payment.id,
        });

        setTimeout(() => {
          this.$emit("closeModal");
        }, 200);
        console.log("payment Deleted.");
      }
    },
  },
};
</script>

<style scoped>
/* === NAGŁÓWEK === */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  border-bottom: 1px solid #e9ecef;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.modal-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
}

.payment-badge {
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-success {
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  color: #155724;
}

.badge-danger {
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
  color: #721c24;
}

.btn-close {
  background: transparent;
  border: none;
  font-size: 32px;
  line-height: 1;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-close:hover {
  background: #f8f9fa;
  color: #dc3545;
  transform: rotate(90deg);
}

/* === CIAŁO MODALU === */
.modal-body {
  padding: 32px;
  background: #f8f9fa;
  max-height: 70vh;
  overflow-y: auto;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-title::before {
  content: '';
  width: 4px;
  height: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 2px;
}

/* === KARTA KONTRAHENTA === */
.contractor-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;
}

.section-header .section-title {
  margin-bottom: 0;
}

.email-sent-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 8px;
  border-left: 3px solid #2196f3;
}

.badge-icon {
  font-size: 18px;
}

.badge-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.badge-label {
  font-size: 11px;
  color: #1976d2;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-value {
  font-size: 13px;
  color: #0d47a1;
  font-weight: 500;
}

.contractor-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.contractor-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.contractor-item:hover {
  background: #e9ecef;
  transform: translateX(4px);
}

.item-icon {
  font-size: 20px;
  line-height: 1;
  opacity: 0.8;
}

.item-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.item-label {
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.item-value {
  font-size: 14px;
  color: #212529;
  font-weight: 500;
  word-break: break-word;
}

.item-link {
  color: #667eea;
  text-decoration: none;
  transition: color 0.3s ease;
}

.item-link:hover {
  color: #764ba2;
  text-decoration: underline;
}

/* === FORMULARZ PŁATNOŚCI === */
.payment-form {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
}

.form-control {
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
}

.form-control:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.editor-container {
  border: 2px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
  min-height: 300px;
  transition: all 0.3s ease;
}

.editor-container:focus-within {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* === STOPKA === */
.modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 32px;
  border-top: 1px solid #e9ecef;
  background: white;
  position: sticky;
  bottom: 0;
  z-index: 10;
  gap: 20px;
}

.footer-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
}

.footer-left {
  flex: 1;
}

.footer-right {
  display: flex;
  gap: 12px;
  align-items: center;
}

.footer-type-selector {
  display: flex;
  align-items: center;
  gap: 12px;
}

.footer-label {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
  white-space: nowrap;
}

.footer-type-selector .type-select {
  min-width: 180px;
}

/* === PRZYCISKI === */
.btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn:active {
  transform: translateY(0);
}

/* Przycisk Warning */
.btn-warning {
  background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%);
  color: #212529;
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.3);
}

.btn-warning:hover {
  background: linear-gradient(135deg, #ff9800 0%, #ffc107 100%);
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.4);
}

/* Przycisk Success */
.btn-success {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
}

.btn-success:hover {
  background: linear-gradient(135deg, #20c997 0%, #28a745 100%);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
}

/* Przycisk Info */
.btn-info {
  background: linear-gradient(135deg, #17a2b8 0%, #007bff 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(23, 162, 184, 0.3);
}

.btn-info:hover {
  background: linear-gradient(135deg, #007bff 0%, #17a2b8 100%);
  box-shadow: 0 4px 12px rgba(23, 162, 184, 0.4);
}

/* Przycisk Outline Danger */
.btn-outline-danger {
  background: transparent;
  color: #dc3545;
  border: 2px solid #dc3545;
  padding: 10px 20px;
}

.btn-outline-danger:hover {
  background: #dc3545;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

/* === RESPONSYWNOŚĆ === */
@media (max-width: 768px) {
  .modal-header {
    padding: 16px 20px;
  }
  
  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .modal-title {
    font-size: 20px;
  }
  
  .modal-body {
    padding: 20px;
  }
  
  .contractor-grid {
    grid-template-columns: 1fr;
  }
  
  .form-row {
    grid-template-columns: 1fr;
  }
  
  .modal-footer {
    flex-direction: column;
    gap: 12px;
    padding: 16px 20px;
    align-items: stretch;
  }
  
  .footer-left,
  .footer-actions {
    width: 100%;
    justify-content: center;
  }
  
  .footer-type-selector {
    flex-direction: column;
    align-items: stretch;
    margin-right: 0;
    margin-bottom: 12px;
  }
  
  .footer-type-selector .type-select {
    width: 100%;
  }
  
  .btn {
    flex: 1;
    justify-content: center;
  }
}

/* === TOAST NOTIFICATION === */
.toast-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  z-index: 10000;
  font-weight: 500;
  min-width: 300px;
  max-width: 500px;
}

.toast-icon {
  font-size: 20px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  flex-shrink: 0;
}

.toast-message {
  flex: 1;
  font-size: 14px;
  line-height: 1.4;
}

.toast-success {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
}

.toast-success .toast-icon {
  background: rgba(255, 255, 255, 0.3);
}

.toast-error {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
}

.toast-error .toast-icon {
  background: rgba(255, 255, 255, 0.3);
}

.toast-info {
  background: linear-gradient(135deg, #17a2b8 0%, #007bff 100%);
  color: white;
}

.toast-info .toast-icon {
  background: rgba(255, 255, 255, 0.3);
}

/* Toast animations */
.toast-enter-active {
  animation: toastIn 0.4s ease-out;
}

.toast-leave-active {
  animation: toastOut 0.3s ease-in;
}

@keyframes toastIn {
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes toastOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(400px);
    opacity: 0;
  }
}

@media (max-width: 768px) {
  .toast-notification {
    top: 10px;
    right: 10px;
    left: 10px;
    min-width: auto;
  }
}
</style>
